import { defineMessages } from "react-intl";

export default defineMessages({
  addLine: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.ActivationSettingsComponent.addLine',
    defaultMessage: 'Add a setting line',
  },
  conditionsTitle: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.conditionsTitle',
    defaultMessage: 'Custom conditions',
  },
  conditionsExplanation: {
    id: 'containers.ProductSettings.Activation.conditionsExplanation',
    defaultMessage: '(Define here when and where the uptain® ALGORITHM has the permission to show the popups)',
  },
  noConditionMessage: {
    id: 'containers.ProductSettings.Activation.noConditionMessage',
    defaultMessage: 'No conditions set: The uptain® ALGORITHM has the permission to show this dialog box everytime. If you want to define rules when and where this dialog box should be visible add conditions.',
  },
  addCondition: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.addCondition',
    defaultMessage: 'Add condition',
  },
  trackingCodeExplanation: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.trackingCodeExplanation',
    defaultMessage: '(You may add custom javascript tracking code)',
  },
  noTrackingCodeMessage: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.noTrackingCodeMessage',
    defaultMessage: 'This is the standard setting. You may add custom javascript code that will be executed for tracking purposes.',
  },
  addTrackingCode: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.addTrackingCode',
    defaultMessage: 'Add tracking option',
  },
  unsavedData: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.unsavedData',
    defaultMessage: 'unsaved data',
  },
  openConfigurations: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.openConfigurations',
    defaultMessage: 'Open configurations',
  },
  deleteLine: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.deleteLine',
    defaultMessage: 'Delete setting line',
  },
  editTitle: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.editTitle',
    defaultMessage: 'Edit title',
  },
  deleteWarningTitle: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.deleteWarningTitle',
    defaultMessage: 'Delete setting line?',
  },
  deleteWarningMessage: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.deleteWarningMessage',
    defaultMessage: 'Are you sure you want to delete this setting line?',
  },
  deleteWarningDelete: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.deleteWarningDelete',
    defaultMessage: 'Delete',
  },
  deleteWarningDontDelete: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.SettingLine.deleteWarningDontDelete',
    defaultMessage: "Don't delete",
  },
  discardWarningTitle: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.discardWarningTitle',
    defaultMessage: 'Discard changes?',
  },
  discardWarningMessage: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.discardWarningMessage',
    defaultMessage: 'Are you sure you want to discard the unsaved changes?',
  },
  discardWarningDiscard: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.discardWarningDiscard',
    defaultMessage: 'Discard changes',
  },
  discardWarningDontDiscard: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.discardWarningDontDiscard',
    defaultMessage: "Don't discard changes",
  },
  successfullText: {
    id: 'containers.Dashboard.ActiavtionSettigns.ActivationTypesSettings.Settings.successfullText',
    defaultMessage: 'Saved',
  },
  popupDisplayedOption: {
    id: 'containers.Dashboard.ActiavtionDesignSettigns.ActivationTypes.TrackingOption.popupDisplayedOption',
    defaultMessage: 'Popup is displayed',
  },
  popupClosedOption: {
    id: 'containers.Dashboard.ActiavtionDesignSettigns.ActivationTypes.TrackingOption.popupClosedOption',
    defaultMessage: 'User closes popup',
  },
  sessionMarkedOption: {
    id: 'containers.Dashboard.ActiavtionDesignSettigns.ActivationTypes.TrackingOption.sessionMarkedOption',
    defaultMessage: 'Session marked as possible Regain',
  },
  popupMinimizedShownOption: {
    id: 'containers.Dashboard.ActiavtionDesignSettigns.ActivationTypes.TrackingOption.popupMinimizedShownOption',
    defaultMessage: 'Minimized popup is shown',
  },
  popupMinimizedClosedOption: {
    id: 'containers.Dashboard.ActiavtionDesignSettigns.ActivationTypes.TrackingOption.popupMinimizedClosedOption',
    defaultMessage: 'User closes minimized popup',
  },
});
